import React from 'react';
import { ProductType } from '@/@types';
import { Card, Element } from '@/components/core';
import { msg } from '@lingui/core/macro';
import clsx from 'clsx';
import { Trans as TransReact } from '@lingui/react';
import { Image } from '@/components/core/components/atoms';
import { isProductOfType } from '@/services/api/parsers/utils';
import * as styles from './actions.styles';

const actionsMessages: { [key: string]: ReturnType<typeof msg> } = {
  movies: msg`Stream`,
  series: msg`Stream`,
  apps: msg`Download`,
  music: msg`Listen on`,
  others: msg`Links`,
};

const Actions: React.FC<{ product: ProductType }> = ({ product }) => {
  if (!isProductOfType(product, ['movies', 'series']) || product.extraInfo.providers.length === 0) {
    return null;
  }
  return (
    <div className={styles.root}>
      <ul className={styles.options}>
        <Element as="li" className={clsx(styles.option, {})}>
          <TransReact id={actionsMessages[product.category.name]?.id || actionsMessages.others.id} />
        </Element>
      </ul>
      <Card className={styles.providers}>
        {product.extraInfo.providers.map((provider) => {
          return (
            <a target="_blank" rel="noopener nofollow" className={styles.provider} href={provider.url} key={provider.name}>
              <Image src={`/logos/${provider.name}.png`} alt={provider.name} />
            </a>
          );
        })}
      </Card>
    </div>
  );
};

export default Actions;
